import { atom, useRecoilState } from 'recoil';

import ELEMENT from 'common/element';

import ClearableInput from 'components/common/ClearableInput/ClearableInput';

import './LogOverviewFilter.scss';

export const overviewFilterTextState = atom({
  key: 'overviewFilterText',
  default: '',
});

function LogOverviewFilter(): JSX.Element {
  const [filterText, setFilterText] = useRecoilState(overviewFilterTextState);

  const onFilterInputChange = (value: string): void => {
    setFilterText(value);
  };

  return (
    <ClearableInput
      value={filterText}
      className="LogOverviewFilter"
      size="sm"
      onChange={onFilterInputChange}
      testId={ELEMENT.overviewFilterInput}
    />
  );
}

export default LogOverviewFilter;
